import { useContext } from 'react';
import {
  CorporateFormContext,
  CorporateFormContextType,
} from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/CorporateFormContext';

export const useCorporateFormContext = (): CorporateFormContextType => {
  const context = useContext(CorporateFormContext);
  if (!context) {
    throw new Error(
      'useCorporateFormContext must be used within a CorporateFormProvider'
    );
  }
  return context;
};
